import { BsLock } from "react-icons/bs";
import { useTranslation } from "react-i18next";

export type UpgradePromptKind = "executive" | "business";

type Props = {
  kind: UpgradePromptKind;
  /** Users list: two lock sizes (mobile / desktop). Event card: single small lock. */
  variant?: "stacked" | "compact";
};

export function ConnectionUpgradePrompt({ kind, variant = "stacked" }: Props) {
  const { t } = useTranslation();
  const titleKey =
    kind === "executive"
      ? "connections.upgradeToExecutiveMembership"
      : "connections.upgradeToBusinessMembership";

  const lockIcon =
    variant === "compact" ? (
      <BsLock
        size={14}
        className="ms-1 flex-shrink-0 text-secondary opacity-75"
      />
    ) : (
      <>
        <BsLock
          size={14}
          className="d-inline d-md-none ms-1 flex-shrink-0 text-secondary opacity-75"
        />
        <BsLock
          size={20}
          className="d-none d-md-inline ms-1 flex-shrink-0 text-secondary opacity-75"
        />
      </>
    );

  return (
    <span className="d-inline-flex align-items-center w-100">
      {t(titleKey)}
      {lockIcon}
    </span>
  );
}
